export const API_PATH_ApiWWRStartZipFileCreationV1 = '/services/wrong-way-resolution/apiWWRStartZipFileCreation-v1';
